/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown>, previousStep: NonNullable<unknown>, step: NonNullable<unknown> }} Notifications_Case_Step_Changed_BodyInputs */

const en_notifications_case_step_changed_body = /** @type {(inputs: Notifications_Case_Step_Changed_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case ${i?.caseNumber} advanced from ${i?.previousStep} to ${i?.step}.`)
};

const pt_br2_notifications_case_step_changed_body = /** @type {(inputs: Notifications_Case_Step_Changed_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O caso ${i?.caseNumber} avançou de ${i?.previousStep} para ${i?.step}.`)
};

/**
* | output |
* | --- |
* | "Case {caseNumber} advanced from {previousStep} to {step}." |
*
* @param {Notifications_Case_Step_Changed_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_case_step_changed_body = /** @type {((inputs: Notifications_Case_Step_Changed_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Case_Step_Changed_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_case_step_changed_body(inputs)
	return pt_br2_notifications_case_step_changed_body(inputs)
});